<template>
  <div class="section basic-section">
    <div class="card">
      <h2><span class="update-label"><span class="label-face">毎日<br>更新</span></span><span class="head-str">新着占い</span></h2>
      <div class="list-wrap">
        <div class="list-item"
          v-for="(item,idx) of menuList"
          :key="idx"
          :class="`menu-${item.id}`"
          @click.stop="onMenuItemClick(idx)"
        >
          <div class="thumbnail" :class="{nophoto: !item.counselor || !item.counselor.thumbnail}">
            <img v-if="!!item.counselor && !!item.counselor.thumbnail" :src="item.counselor.thumbnail" alt="" @error="onImgLoadError">
          </div>
          <div class="sec-top">
            <span class="update">{{item.updateObj.format('M/D')}}</span>
            <span class="new" v-if="item.isNew">NEW</span>
          </div>
          <div class="sec-body">
            <p>{{item.name}}</p>
          </div>
        </div>
      </div>
      <div class="section-foot">
        <span class="btn btn-tagnew" @click="onTagNewClick"><span>いますぐチェック</span></span>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'NewArrivalMenus',
  props: {
    parentPage: {
      type: String,
      default: '',
    },
    sectionData: {
      type: Array,
      default() {
        return []
      }
    },
    isSubscrEnable: {
      type: Boolean,
      require: true,
    },
    subscUrl: {
      type: String,
      require: true,
    },
  },
  computed: {
    menuList(){
      const rtn = []
      if(!!this.sectionData && this.sectionData.length > 0) {
        const newlim = new moment(this.sectionData[0].openedAt) //一番上を最新とする
        this.sectionData.forEach(item => {
          const update = new moment(item.openedAt)
          rtn.push({
            ...item,
            updateObj: update,
            isNew: update.isSame(newlim, 'day') //同日ならNEW
          })
        })
      }
      return rtn
    }
  },
  mounted(){
    //console.log('セクションデータ%O', this.sectionData)
  },
  methods: {
    onMenuItemClick(val){
      if (this.isSubscrEnable) {
        location.href = `/menu/${this.sectionData[val].id}`
      } else {
        location.href = this.subscUrl
      }
    },
    onTagNewClick(){
      if (this.isSubscrEnable) {
        location.href = '/tag/new'
      } else {
        location.href = this.subscUrl
      }
    },
    onImgLoadError(e){
      e.target.parentNode.classList.add('nophoto')
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
$basic_side_padding: 20px;
$basic_top_padding: 25px;
$basic_bottom_padding: 20px;

.section {
  width: 100%;
  height: auto;
  color: $col_base_font;

  .card {
    width: 100%;
    height: 100%;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    background: transparent;
    padding: 0;
  }

  &.basic-section {
    max-width: 580px;
    margin: auto;
    padding-top: $basic_top_padding;
    padding-bottom: $basic_bottom_padding;
    padding-left: $basic_side_padding;
    padding-right: $basic_side_padding;
  }

  h2 {
    width: 100%;
    text-align: center;
    position: relative;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    background: linear-gradient(86.53deg, #ff7497 21.4%, #cb8bff 76.64%);
    .head-str {
      color: white;
      font-size: 24px;
      text-align: center;
    }
    .update-label {
      background: white;
      display: flex;
      width: 50px;
      height: 50px;
      border-radius: 25px;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 16px;
      margin: auto;
      .label-face {
        font-size: 14px;
        line-height: 1.1;
        display: inline-block;
        color: $col_temp_key1;
        background: linear-gradient(86.53deg, #ff7497 21.4%, #cb8bff 76.64%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  .list-wrap {
    background: $col_white_translucent;
    border-left: 2px solid  #ff7497;
    border-right: 2px solid  #cb8bff;
    padding: 6px 16px;

    .list-item {
      width: 100%;
      height: 85px;
      position: relative;
      padding: 10px 16px 10px 66px;
      border-bottom: 1px solid #dcdfe2;
      cursor: pointer;
      &:last-child {
        border-bottom: none;
      }
      &::after {
        content: "";
        width: 10px;
        height: 17px;
        background: url(/static/img/common/ic_grad_arrow.png) no-repeat center center;
        background-size: 100% auto;
        display: inline-block;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;

      }

      .thumbnail {
        width: 55px;
        height: 55px;
        border-radius: 30px;
        overflow: hidden;
        position: absolute;
        left: 0;
        bottom: 10px;
        img {
          width: 100%;
          object-fit: cover;
        }
        &.nophoto {
          background: $col_lite_gradient;
          img {
            display: none;
          }
          &::after {
            content: 'NO IMAGE';
            width: 100%;
            height: 100%;
            line-height: 1;
            transform: scale(0.8);
            font-size: 10px;
            color: $col_temp_key1;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
      .sec-top {
        margin-bottom: 5px;
        .update {
          color: #656d78;
          font-size: 12px;
        }
        .new {
          font-size: 10px;
          font-weight: bold;
          display: inline-block;
          color: white;
          background: linear-gradient(86.53deg, #ff7497 21.4%, #cb8bff 76.64%);
          padding: 2px 6px;
          border-radius: 4px;
          line-height: 1;
        }
      }
      .sec-body {
        p {
          font-size: 15px;
          font-weight: bold;
          line-height: 21px;
          margin: 0;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /* autoprefixer: ignore next */
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }
  }
  .section-foot {
    background: linear-gradient(86.53deg, #ff7497 21.4%, #cb8bff 76.64%);
    padding: 16px 0 24px;
    .btn-tagnew {
      height: 50px;
      max-width: 270px;
      border-radius: 25px;
      background: white;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin: 0 auto;
      & > span {
        line-height: 1;
        font-size: 18px;
        font-weight: bold;
        color: $col_temp_key1;
        background: linear-gradient(86.53deg, #ff7497 21.4%, #cb8bff 76.64%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      &::after {
        content: "";
        width: 10px;
        height: 17px;
        background: url(/static/img/common/ic_grad_arrow.png) no-repeat center center;
        background-size: 100% auto;
        display: inline-block;
        margin-left: 5px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/NewArrivalMenus.vue